import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    var clonedSliderInstance = null;

    // room card more info
    document.querySelectorAll('.mel-popup-open-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var popup = link.closest('.mel-info');
            if (!popup) return;
            var mePopupItem = popup.parentElement.querySelector('.me-popup-item');
            if (!mePopupItem) return;

            var clonedPopup = mePopupItem.cloneNode(true); // clone contents (events not copied)
            var inner = document.querySelector('.me-popup-inner');
            if (!inner) return;
            inner.appendChild(clonedPopup);

            var clonedSlider = clonedPopup.querySelector('.gallery-slider');
            if (clonedSlider) {
                clonedSliderInstance = tns({
                    container: clonedSlider,
                    items: 1,
                    slideBy: 1,
                    nav: false,
                    controls: false,
                    autoplay: false,
                    speed: 300,
                    loop: false
                });

                var parent = clonedSlider.parentElement;
                var prev = parent.querySelector('.slick-prev') || parent.querySelector('.left-arrow');
                var next = parent.querySelector('.slick-next') || parent.querySelector('.right-arrow');
                if (prev) prev.addEventListener('click', function (ev) { ev.preventDefault(); clonedSliderInstance.goTo('prev'); });
                if (next) next.addEventListener('click', function (ev) { ev.preventDefault(); clonedSliderInstance.goTo('next'); });
            }

            var popupScroll = window.scrollY || window.pageYOffset;
            document.body.style.top = '-' + popupScroll + 'px';
            document.body.style.position = 'fixed';

            document.querySelectorAll('.me-popup').forEach(function (p) { p.classList.add('active'); });
            e.preventDefault();
        });
    });

    document.querySelectorAll('ul.me-popup-tabs li').forEach(function (li) {
        li.addEventListener('click', function () {
            if (li.classList.contains('rfp-link')) {
                ClosePopup();
                var target = document.getElementById('requestAProposal');
                if (target) {
                    var top = target.getBoundingClientRect().top + window.pageYOffset - 50;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                }

                var hotelId = li.querySelector('a') ? li.querySelector('a').dataset.hotel : null;
                if (hotelId) {
                    var select = document.getElementById('hotelFormSelect');
                    if (select) {
                        select.value = hotelId;
                        var evt = new Event('change', { bubbles: true });
                        select.dispatchEvent(evt);
                    }
                }
            } else {
                var activeTab = li.querySelector('a') ? li.querySelector('a').dataset.tab : null;

                document.querySelectorAll('ul.me-popup-tabs li').forEach(function (x) { x.classList.remove('active'); });
                li.classList.add('active');

                document.querySelectorAll('.me-popup-inner .me-popup-content').forEach(function (c) { c.classList.remove('active'); });
                if (activeTab) {
                    var targetContent = document.querySelector('.me-popup-inner .me-popup-content[data-tab="' + activeTab + '"]');
                    if (targetContent) targetContent.classList.add('active');
                }

                // if we are switching to the gallery tab, reinitialize/refresh the slider
                if (activeTab === 'mel-gallery' || activeTab === 'met-gallery') {
                    if (clonedSliderInstance) {
                        try {
                            if (typeof clonedSliderInstance.refresh === 'function') clonedSliderInstance.refresh();
                            else if (typeof clonedSliderInstance.rebuild === 'function') clonedSliderInstance.rebuild();
                            else if (typeof clonedSliderInstance.update === 'function') clonedSliderInstance.update();
                            else clonedSliderInstance.goTo(0);
                        } catch (err) {
                            try { clonedSliderInstance.goTo(0); } catch (e) { }
                        }
                    }
                }
            }

            return false;
        });
    });

    document.querySelectorAll('.me-popup-close').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            ClosePopup();
        });
    });

    function ClosePopup() {
        var scrollY = document.body.style.top || '0';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);

        document.querySelectorAll('.me-popup').forEach(function (p) { p.classList.remove('active'); });
        var inner = document.querySelector('.me-popup-inner');
        if (inner) inner.innerHTML = '';
        clonedSliderInstance = null;
    }
});


